import portfolioNew from '../src/assets/images/portfolioNew.png';
const logoText = "AAKASH";
const meta = {
    title: "Aakash",
    description: "I’m Aakash - A Full stack Engineer",
};

const introData = {
    title: "I’m Aakash",
    animated: {
        first: "I'm a Software Engineer",
        second: "I develop cool websites",
        third: "exploring new opportunities",
    },
    description: "I'm a Full Stack Engineer from India, who focuses on user friendly and interactive design Implementations with clean interfaces.",
    your_img_url: "https://images.unsplash.com/photo-1514790193030-c89d266d5a9d",
};

const dataAbout = {
    title: "a bit about myself",
    aboutme: "Diligent software engineer with 4+ years of experience in Education / communication application and software development. Passionate to build innovative and cutting-edge business solutions for the impressive suite of clients within its global reach. In previous roles, slashed call connection time by 45% and ensured 98% on-time project completion. Also identified and dealt with a significant process bottleneck that boosted coding efficiency by 35% when resolved.",
};
const workTimeline = [{
    jobtitle: "Remote Engineer",
    where: "Alira Health",
    date: " August 2022 - Present",
},
{
    jobtitle: "Lead Software Engineer",
    where: "Vaco Enterprise",
    date: "October 2021 - August 2022",
},
{
    jobtitle: "Software Engineer",
    where: "Vaco Enterprise",
    date: "May 2021 - October 2021",
},
{
    jobtitle: "Full Stack Developer",
    where: "Eckovation",
    date: "June 2019 - May 2021",
},
{
    jobtitle: "Full Stack Developer",
    where: "Code Quotient",
    date: "June 2018 - August 2018",
},
];

const skills = [{
    name: "React JS",
    value: 90,
},
{
    name: "Node JS",
    value: 75,
},
{
    name: "HTML + SCSS + BootStrap",
    value: 85,
},
{
    name: "Javascript",
    value: 80,
},
{
    name: "Python",
    value: 65,
},
{
    name: "Mongo / NoSQL",
    value: 70,
},
{
    name: "AWS / Google Cloud",
    value: 60,
},
];

const services = [{
    title: "Web Application Development",
    description: "Design, develop, and maintain code for the platform. Making improvements to the components of the platform. Solving Platform issues that arise in the day-to-day operations. Improvement of the platform’s security.",
},
{
    title: "Freelance Frontend Development",
    description: "Connect with me to discuss more and have your content developed.",
}
];

const dataPortfolio = [{
    img: '' + portfolioNew,
    description: "a little more refined Portfolio Website. Although the work is still in Progress... ",
    link: "http://aakashbansal.co.in/",
},
];

const contactConfig = {
    YOUR_EMAIL: "aakashbansal837@gmail.com",
    YOUR_PHONE: "+91 7015903806",
    description: "Just drop me an Email to connect or follow me on the shared social media handles and drop a message there.",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_nvcmxkn",
    YOUR_TEMPLATE_ID: "template_93ky0bz",
    YOUR_USER_ID: "-B9houFC-PiarQLUA",
};

const socialProfiles = {
    github: "https://github.com/Aakashbansal837",
    facebook: "https://www.instagram.com/insta.aakashbansal/",
    linkedin: "https://www.linkedin.com/in/aakash-bansal-4b6852153/",
    twitter: "https://twitter.com/bansal837",
};
export {
    meta,
    dataAbout,
    dataPortfolio,
    workTimeline,
    skills,
    services,
    introData,
    contactConfig,
    socialProfiles,
    logoText,
};
